// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__zDZaU","content":"TermsOfServicePage_content__2oT0U"};